// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/ng-img-crop/compile/minified/ng-img-crop.css
// module id = 261
// module chunks = 0